module.exports = __webpack_public_path__ + "assets/retina_GoldenSectionDetailed.8aaf7c1b8af2b09640efef5553ddaee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_GoldenSectionDetailed.png
// module id = 671
// module chunks = 0